import CalendarChannelPickerProps from './CalendarChannelPicker.props';
import { observer } from 'mobx-react-lite';
import { TextField } from '@fluentui/react/lib/TextField';
import generateBorderStyle from 'owa-calendar-forms-common/lib/utils/generateBorderStyle';
import * as React from 'react';

const styles = require('./CalendarChannelPicker.scss');
const classNames = require('classnames');

export default observer(function CompositePickerPlaceholder(props: CalendarChannelPickerProps) {
    const borderColorStyle = generateBorderStyle(props.colorScheme);

    return (
        <div
            className={classNames(
                styles.container,
                !props.readonly ? borderColorStyle.bottomBorder : null
            )}>
            <TextField
                styles={{
                    field: classNames(styles.container, props.styles?.textField),
                }}
                autoComplete={'off'}
                borderless={true}
                readOnly={props.readonly}
                value={props.defaultValue}
            />
        </div>
    );
});
